import { Component, Input, OnInit } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
import { EffectivenessModel, EvidenceSampleEditModel } from "../../../shared/models";
import { EffExpansionPanelComponent } from "../../common/eff-expansion-panel/eff-expansion-panel.component";

@Component({
    selector: "eff-test-instructions-info-box",
    templateUrl: "./eff-test-instructions-info-box.component.html",
    styleUrls: ["./eff-test-instructions-info-box.component.scss"],
    imports: [TranslatePipe, EffExpansionPanelComponent],
    viewProviders: [provideTranslationScope(scope)]
})
export class EffTestInstructionsInfoBoxComponent implements OnInit {
    @Input() effectivenessGuid: string;
    @Input() samples: EvidenceSampleEditModel[];
    @Input() effectivenessModel: EffectivenessModel;
    @Input() showEvidenceUploadInstructions: boolean = false;
    @Input() panelOpenState: boolean = false;

    constructor() {}

    ngOnInit(): void {}
}
